<script>
import { mapGetters, mapMutations } from 'vuex'
import stepsMixin from '@/mixins/stepsMixin'
export default {
	mixins: [stepsMixin],
	components: {
		SvgIcon: () => import('@/components/SvgIcon'),
	},

	data() {
		return {
			query: '',
		}
	},

	computed: {
		filteredClients() {
			if(!this.query) {
				return this.allClients
			}
			return this.searchClients(this.query)
		},
		...mapGetters({
			allClients: 'arceClients/allClients',
			searchClients: 'arceClients/searchClients'
		})
	},

	methods: {
		...mapMutations({
			showSearchClient: 'arceStatus/showSearchClient'
		})
	},

	mounted() {
		this.hiddenSteps()
		this.showSteps('myTourClients')
	}

}
</script>
<template>
	<div class="d-flex flex-wrap px-1 py-1 s-single">
		<div class="col-12 p-0">
			<div class="d-flex flex-wrap py-1">
				<div class="col-12 px-2 py-2">
					<div class="s-panel" data-v-step="1">
						<div class="s-panel__header bg-light p-3">
							<div class="d-flex align-items-center">
								<div class="s-element__icon">
									<img src="@/assets/simulator/account_120.png" alt="">
								</div>
								<div>
									<p class="m-0">Cliente</p>
									<h3 class="title">Vistos recientemente</h3>
								</div>
								<div class="ml-auto d-flex">
									

									<div class="ml-3 s-btn-group">
										<button @click="showSearchClient" class="s-btn s-btn--outline" data-v-step="2">
											Nuevo
										</button>
										<button class="s-btn s-btn--outline">
											Importar
										</button>
										
									</div>
								</div>
							</div>
							<div class="d-flex align-items-center">
								<div>
									<p>2 elementos - Se actualizó hace unos segundos</p>
								</div>
								<div class="ml-auto d-flex align-items-center s-table__controls">
									<div class="s-input">
										<input data-v-step="3" type="text" placeholder="Buscar en esta lista" v-model="query">
										<svg-icon class="mx-2" name="search" />
										<span @click="query = ''" v-if="query">
											<svg-icon class="mx-2 s-input__delete" name="close" />
										</span>
									</div>
									<button class="px-2 mx-1">
										<svg-icon name="settings" />
									</button>
									<button class="px-2 mx-1">
										<svg-icon name="table" />
									</button>
									<button class="px-2 mx-1">
										<svg-icon name="refresh" />
									</button>
									<button class="px-2 mx-1">
										<svg-icon name="edit" />
									</button>
									
									<button class="px-2">
										<svg-icon name="chart" />
									</button>
									<button class="px-2">
										<svg-icon name="filterList" />
									</button>
								</div>
							</div>
						</div>
						<div class="s-panel__body p-0">
							<table class="s-table w-100">
								<thead>
									<tr>
										<th></th>
										<th>
											NOMBRE COMERCIAL DEL CLIENTE
										</th>
										<th>
											NO. DE CLIENTE
										</th>
										<th>
											PROPIETARIO DEL CLIENTE
										</th>
									</tr>
								</thead>
								<tbody v-if="filteredClients.length">
									
									<tr v-for="(client, index) in filteredClients" :key="`client_${index}_${client.id}`">
										<td>
											{{index + 1}}
										</td>
										<td>
											<router-link   data-v-step="4" :to="{name: 'arce-client', params: {id: client.id}}">
											<text-highlight :queries="[query]">	{{client.name}} {{client.code}} </text-highlight>
											</router-link>
										</td>
										<td>
											<text-highlight :queries="[query]">{{client.code}}</text-highlight>
										</td>
										<td>
											{{client.owner}}
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr>
										<td colspan="4" class="text-center">
											No encontramos clientes con esta busqueda {{ query }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 col-lg-8 col-xl-9 p-0">
			<div class="d-flex flex-wrap">
				<div class="col-12 px-2 py-2">
					
				</div>

				<div class="col-12 p-2">
					
				</div>

				<div class="col-12 px-2 py-2">
					<div class="s-panel h-100">
						
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 col-lg-4 col-xl-3 p-0">
			<div class="d-flex flex-wrap">
				<div class="col-12 px-2 py-2">
					<div class="s-panel">
						
						
					</div>
				</div>
				
			</div>
		</div>	
	</div>
</template>